class Header {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.body = document.body;
        self.scrollDownClass = 'scroll-down';
        self.scrollUpClass = 'scroll-up';
        self.topClass = 'scrolled-to-top';
        self.lastScroll = 0;
        self.isScrolling;
    }

    init() {
        let self = this;
        
        self.onScroll();
    }

    onScroll() {
        let self = this;

        // On scroll
        window.addEventListener("scroll", () => {
            self.scrollShowHide();

            // Clear our timeout throughout the scroll
            window.clearTimeout(self.isScrolling);

            // Set a timeout to run after scrolling ends
            self.isScrolling = setTimeout(function() {
                if ((self.lastScroll - 200) > window.pageYOffset) {
                    self.body.classList.remove(self.scrollDownClass);
                    self.body.classList.add(self.scrollUpClass);
                }

                self.lastScroll = window.pageYOffset;
            }, 66);
        });  

        // On page load
        self.scrollShowHide();
    }

    scrollShowHide(lastScroll) {
        let self = this;        
        let currentScroll = window.pageYOffset;

        if (currentScroll <= 0) {
            self.body.classList.remove(self.scrollUpClass);
            self.body.classList.remove(self.scrollDownClass);
            self.body.classList.add(self.topClass);
            return;
        } else {
            self.body.classList.remove(self.topClass);
        }

        if (currentScroll > self.lastScroll && !self.body.classList.contains(self.scrollDownClass)) {
            // down
            self.body.classList.remove(self.scrollUpClass);
            self.body.classList.add(self.scrollDownClass);
        }
    }
}

export default Header;
